import { render } from "./SidebarDadosTitular.vue?vue&type=template&id=3085bb99&scoped=true"
import script from "./SidebarDadosTitular.vue?vue&type=script&lang=js"
export * from "./SidebarDadosTitular.vue?vue&type=script&lang=js"

import "./SidebarDadosTitular.vue?vue&type=style&index=0&id=3085bb99&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3085bb99"]])

export default __exports__